import {
  Search,
  ListChecks,
  CalendarCheck,
  Navigation,
  ParkingCircle,
  CheckCircle2,
} from "lucide-react";
import { howItWorks } from "../content/site";
import { Container, Reveal, Stagger, StaggerItem } from "./ui";

const ICONS = [Search, ListChecks, CalendarCheck, Navigation, ParkingCircle, CheckCircle2];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="bg-[var(--color-bg-soft)] py-20 sm:py-28">
      <Container>
        <Reveal className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl leading-[1.1] font-extrabold tracking-tight text-navy sm:text-4xl lg:text-5xl">
            {howItWorks.headline}
            <br />
            <span className="text-primary">{howItWorks.headlineAccent}</span>
          </h2>
        </Reveal>

        {/* Desktop horizontal timeline */}
        <Stagger className="relative mt-16 hidden lg:grid lg:grid-cols-6 lg:gap-4">
          <div className="absolute top-7 right-0 left-0 z-0 mx-14 h-0.5 bg-navy/10" />
          {howItWorks.steps.map((step, idx) => {
            const Icon = ICONS[idx];
            return (
              <StaggerItem key={step.number} className="relative z-10 flex flex-col items-center text-center">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl border-4 border-[var(--color-bg-soft)] bg-navy text-white shadow-navy">
                  <Icon size={22} />
                </div>
                <span className="mt-4 text-xs font-extrabold tracking-wide text-primary">
                  {step.number}
                </span>
                <h3 className="mt-1 text-base font-extrabold text-navy">{step.title}</h3>
                <p className="mt-2 text-sm text-navy/55">{step.text}</p>
              </StaggerItem>
            );
          })}
        </Stagger>

        {/* Mobile vertical timeline */}
        <Stagger className="relative mt-14 flex flex-col gap-8 lg:hidden">
          <div className="absolute top-2 bottom-2 left-7 w-0.5 bg-navy/10" />
          {howItWorks.steps.map((step, idx) => {
            const Icon = ICONS[idx];
            return (
              <StaggerItem key={step.number} className="relative z-10 flex items-start gap-5">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl border-4 border-[var(--color-bg-soft)] bg-navy text-white shadow-navy">
                  <Icon size={22} />
                </div>
                <div className="pt-1">
                  <span className="text-xs font-extrabold tracking-wide text-primary">
                    {step.number}
                  </span>
                  <h3 className="mt-0.5 text-base font-extrabold text-navy">{step.title}</h3>
                  <p className="mt-1 text-sm text-navy/55">{step.text}</p>
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>
      </Container>
    </section>
  );
}
